import type { CSSProperties } from 'react';
import { affichee } from './palette.js';

/**
 * La couleur d'une DONNÉE (un projet, une habitude) atteint un composant du kit par une
 * variable posée à l'usage — jamais par une classe par couleur, ni par un `backgroundColor`
 * écrit ici : c'est le composant qui décide où la teinte va (fond, point, trait). Une couleur
 * enregistrée avant Braise 2 passe par `affichee()` : elle prend son ton d'aujourd'hui.
 */
export function teinte(couleur: string | null | undefined, variable = '--teinte'): CSSProperties {
  return couleur ? ({ [variable]: affichee(couleur) } as CSSProperties) : {};
}
